<template>
    <slot name="list-items">
        <li
            class="flex justify-between items-center py-4 first:pt-0 last:pb-0 gap-2 lg:gap-6 @container"
        >
            <div
                class="flex flex-col w-3/4 @lg:flex-grow lg:items-center justify-start @lg:justify-between @lg:flex-row @lg:gap-8"
            >
                <div class="flex gap-2">
                    <Icon icon="bed" class="hidden @lg:block" />
                    <p
                        class="text-slate-800 text-base font-medium mb-1 lg:mb-0"
                    >
                        {{ event.name }}
                    </p>
                </div>

                <p
                    class="text-slate-800 text-sm lg:text-lg font-medium @lg:text-right"
                >
                    <span v-if="event.min_points">
                        {{
                            event.min_points
                                ? event.min_points.toLocaleString('en-US')
                                : 'NA'
                        }}
                        points
                    </span>
                    <span v-else>
                        {{
                            Filters.formatThousand(pointsAndCashRate.points)
                        }}
                        Points +
                        {{ Filters.formatPriceInCents(pointsAndCashRate.cash) }}
                    </span>
                    <OrFor :item="event" :nights="nights" />
                </p>
            </div>
            <div class="flex justify-end">
                <a
                    :href="event.view_url"
                    class="px-4 py-2.5 bg-orange-600 rounded shadow justify-center items-center gap-2 text-white text-sm font-medium transition-colors hover:bg-red-400 active:bg-red-400 focus:outline-slate-200 disabled:opacity-50 disabled:bg-orange-600"
                    target="_blank"
                >
                    Book
                </a>
            </div>
        </li>
    </slot>
</template>
<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useCalendarStore } from '@/store/calendar';
import Filters from '@/filters/index.js';
import OrFor from '@/components/calendar/partials/or-for.vue';
import Icon from '@/components/ui/icon/icon.vue';

const store = useCalendarStore();

const props = defineProps({
    event: { type: Object, required: true },
});

const { nights } = storeToRefs(store);

const pointsAndCashRate = computed(() => {
    const rate = props.event.rates.find(
        (rate) => rate.name === 'Points + Cash'
    );
    const p = rate?.points || 0;

    const c = rate?.rate || 0;

    return {
        points: p,
        cash: c,
    };
});
</script>
